import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const subscriptionCreatedV1Schema = eventEnvelopeSchema.extend({
  plan: z.string().min(1).max(128),
  billingPeriod: z.string().min(1).max(64).optional(),
  stripeSubscriptionId: z.string().min(1).max(256).optional(),
});

export type SubscriptionCreatedV1 = z.infer<typeof subscriptionCreatedV1Schema>;

export const SUBSCRIPTION_CREATED_V1_DETAIL_TYPE = 'subscription.created.v1' as const;
